/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function SamsungLogo(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 141 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18442_162877)">
        <g clipPath="url(#clip1_18442_162877)">
          <path
            d="M9.50326 27.8625C9.69729 28.3499 9.63577 28.9746 9.54112 29.3532C9.37549 30.0252 8.92118 30.7114 7.57717 30.7114C6.31836 30.7114 5.55171 29.9826 5.55171 28.8847V26.9302H0.142578V28.4824C0.142578 32.9782 3.67768 34.3364 7.46833 34.3364C11.1123 34.3364 14.1126 33.0965 14.5906 29.7318C14.8367 27.9903 14.6568 26.8498 14.5717 26.4286C13.7198 22.2073 6.07227 20.9485 5.49965 18.587C5.42015 18.2387 5.41352 17.8776 5.48072 17.5269C5.62269 16.8786 6.06281 16.1735 7.32163 16.1735C8.50473 16.1735 9.19092 16.9023 9.19092 18.0002V19.2495H14.2215V17.8298C14.2215 13.4382 10.2794 12.752 7.43047 12.752C3.84331 12.752 0.913959 13.9398 0.379198 17.2288C0.237226 18.128 0.213564 18.9325 0.426522 19.9452C1.30202 24.0624 8.46213 25.2549 9.50326 27.8625Z"
            fill="#034EA2"
          />
          <path
            d="M21.7225 13.3944L17.9839 33.5497H23.4309L26.1899 15.2589H26.3034L28.9867 33.5497H34.4053L30.6904 13.3896L21.7225 13.3944ZM52.1755 13.3944L49.691 28.8031H49.5726L47.0929 13.3944H38.8727L38.4278 33.5497H43.4726L43.5956 15.4293H43.7092L47.0739 33.5497H52.1897L55.5591 15.434H55.668L55.7957 33.5497H60.8357L60.3909 13.3896L52.1755 13.3944Z"
            fill="#034EA2"
          />
          <path
            d="M75.0326 27.8244C75.2266 28.3119 75.1651 28.9365 75.0704 29.3151C74.9048 29.9871 74.4505 30.6733 73.1065 30.6733C71.8477 30.6733 71.081 29.9445 71.081 28.8466V26.8921H65.6719V28.4444C65.6719 32.9401 69.207 34.2983 72.9976 34.2983C76.6416 34.2983 79.6419 33.0584 80.1199 29.6937C80.366 27.9522 80.1861 26.8117 80.101 26.3905C79.2491 22.1692 71.6016 20.9104 71.0289 18.5489C70.9494 18.2006 70.9428 17.8395 71.01 17.4889C71.152 16.8405 71.5921 16.1354 72.8509 16.1354C74.034 16.1354 74.7202 16.8642 74.7202 17.9621V19.2114H79.7508V17.7917C79.7508 13.4001 75.8087 12.7139 72.9598 12.7139C69.3726 12.7139 66.4433 13.9017 65.9085 17.1907C65.7665 18.0899 65.7429 18.8944 65.9558 19.9071C66.8313 24.0243 73.9914 25.2169 75.0326 27.8244Z"
            fill="#034EA2"
          />
          <path
            d="M91.9515 30.5316C93.3523 30.5316 93.7829 29.5662 93.8823 29.0741C93.9249 28.8564 93.9296 28.563 93.9296 28.3027V13.3956H99.0312V27.8436C99.0321 28.2857 99.0165 28.7277 98.9838 29.1687C98.6289 32.931 95.657 34.1519 91.9515 34.1519C88.2413 34.1519 85.2694 32.931 84.9144 29.1687C84.9002 28.97 84.8624 28.2128 84.8671 27.8436V13.3909H89.9686V28.298C89.9639 28.563 89.9734 28.8564 90.016 29.0741C90.1106 29.5662 90.546 30.5316 91.9515 30.5316ZM116.598 13.3956L116.872 29.216H116.763L112.126 13.3956H104.649V33.338H109.603L109.329 16.9686H109.438L114.411 33.338H121.591V13.3956H116.598ZM133.989 30.3234C135.447 30.3234 135.958 29.4006 136.048 28.8564C136.091 28.634 136.095 28.35 136.095 28.0992V25.1651H134.027V22.231H141.168V27.6354C141.168 28.014 141.159 28.2885 141.097 28.9605C140.766 32.6328 137.581 33.9437 134.008 33.9437C130.435 33.9437 127.255 32.6328 126.919 28.9605C126.862 28.2885 126.848 28.014 126.848 27.6354V19.155C126.848 18.7953 126.896 18.1612 126.933 17.8299C127.383 14.0582 130.435 12.8467 134.008 12.8467C137.581 12.8467 140.714 14.0487 141.083 17.8252C141.15 18.4688 141.131 19.1502 141.131 19.1502V19.827H136.048V18.6959C136.048 18.6959 136.048 18.2227 135.986 17.9293C135.892 17.4844 135.513 16.4622 133.97 16.4622C132.503 16.4622 132.073 17.4324 131.964 17.9293C131.902 18.1943 131.879 18.554 131.879 18.8805V28.0945C131.879 28.35 131.888 28.634 131.926 28.8611C132.021 29.4006 132.532 30.3234 133.989 30.3234Z"
            fill="#034EA2"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18442_162877">
          <rect width="141" height="48" fill="white" />
        </clipPath>
        <clipPath id="clip1_18442_162877">
          <rect
            width="141.026"
            height="22"
            fill="white"
            transform="translate(0.142578 12.5264)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

SamsungLogo.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default SamsungLogo
